<template>

    <div class="page" :class="classes">
        <slot></slot>
    </div>

</template>

<style scoped lang="scss">

    .page {
        background: $color-bg;
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        .page-body-container {
            display: flex;
            flex-grow: 1;
            height: 100%;
        }
        .page-body {
            box-sizing: border-box;
            flex-grow: 1;
            padding: 15px;
            padding-bottom: 120px;
            position: relative;
        }
    }

    .page.page-fixed .page-body {
        margin: 0 auto;
        max-width: $screen-xl-min;
        width: 100%;
    }

</style>

<script>

export default {

    props: {
        fixed: {
            type: Boolean,
            default: false,
        },
    },

    computed: {

        classes() {
            return {
                'page-fixed': this.fixed,
            }
        },

    },

}

</script>